module.exports = __webpack_public_path__ + "img/happytable_info2.12d15721.jpg";